import styled, { css } from 'styled-components'
import { animated } from 'react-spring'
import theme from 'stories/utils/theme'

export const Component = styled.div`
    display: flex;
    flex-direction: column;
    padding-bottom: 50px;
`

export const Container = styled.div`
    display: flex;
    width: 100%;
    align-self: center;
    justify-self: center;
    height: 550px;
    @media (max-width: 750px) {
        min-height: 525px;
        button {
            display: none;
        }
    }
`

export const CarouselWrapper = styled.div`
    flex: 3;
    margin-right: 150px;
    transform: translateZ(0);
`

export const CarouselCard = styled(animated.div)<{ fullWidth?: boolean }>`
    ${({ fullWidth }) =>
        fullWidth
            ? css`
                  width: 100%;
              `
            : ''}
`

export const CarouselIconButton = styled.div<{ isLeft?: boolean; revertColors?: boolean; moveButtonsInsideCard?: boolean }>`
    z-index: 1;
    flex: 1;

    min-height: 450px;
    display: flex;
    align-items: center;
    justify-content: center;
    .circle {
        cursor: pointer;
        display: grid;
        place-content: center;
        width: 75px;
        height: 75px;
        background-color: ${({ revertColors }) => (revertColors ? theme.colors.white : theme.colors.accentBlue)};
        border-radius: 50%;
        ${({ moveButtonsInsideCard, isLeft }) =>
            moveButtonsInsideCard
                ? css`
                      position: relative;
                      left: ${isLeft ? 30 : -30}px;
                  `
                : ''}
    }
    svg {
        position: relative;
        left: ${({ isLeft }) => (isLeft ? -3 : 3)}px;
    }
    @media (max-width: 750px) {
        min-height: 0px;
        justify-content: ${({ isLeft }) => (isLeft ? 'flex-end' : 'start')};
        .circle {
            width: 50px;
            height: 50px;
        }
        svg {
            position: relative;
            left: ${({ isLeft }) => (isLeft ? -2 : 2)}px;
        }
    }
`

export const DotsWrapper = styled.div`
    display: flex;
    justify-content: center;
    @media (min-width: 750px) {
        position: relative;
        top: 15px;
        button {
            display: none;
        }
    }
`
interface CarouselDotProps {
    isClicked: boolean
}
export const CarouselDot = styled.div<CarouselDotProps>`
    height: 16px;
    width: 16px;
    background-color: ${({ isClicked }) => (isClicked ? theme.colors.accentBlue : theme.colors.white)};
    border: 2px solid ${theme.colors.accentBlue};
    border-radius: 15px;
    z-index: 9;
    margin: 0 5px;
    cursor: pointer;

    @media (max-width: 750px) {
        margin: 25px 15px;
        height: 12px;
        width: 12px;
    }
`
